// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categoryMenuGrid {
  background-color: #fff !important;
  padding: 10px;
  overflow-x: hidden;
  max-width: 90vw;
}

.createCategoryContainer {
  padding: 10px;
  background-color: #fff !important;
}

.createCategoryHeading {
  font-size: 2rem;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
  color: #5271FF;
  margin-bottom: 10px;
}

.categoryInput{
  width: 100%;
}

.createCategoryForm{
  border: 0.3px solid black;
  border-radius: 5px;
  background-color: #F7F6F9;
  padding: 20px 20px 10px 20px;
  margin-top: 10px;
  font-size: 0.75rem;
}

.createCategoryForm input{
  padding: 5px 5px;
}

.createCategoryForm input::placeholder{
  color: #ADA8A8;
  font-weight: 700;
  font-size: 0.75rem;
}

.createCategorySaveButton{
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.createCategorySaveButton button{
  background: linear-gradient(90deg, #4E6CF3 0%, #3448A3 100%);
  color:#fff;
  border: 0.5px solid #BEBEBE;
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 8px 25px;
  cursor: pointer;
}

/* ── Dark mode ── */
.dark .categoryMenuGrid {
  background-color: #0f172a !important;
  color: #f1f5f9;
}

.dark .createCategoryContainer {
  background-color: #1e293b !important;
  color: #f1f5f9;
}

.dark .createCategoryForm {
  background-color: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .createCategoryHeading {
  color: #818cf8;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/MenuCategory/MenuCategory.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".categoryMenuGrid {\n  background-color: #fff !important;\n  padding: 10px;\n  overflow-x: hidden;\n  max-width: 90vw;\n}\n\n.createCategoryContainer {\n  padding: 10px;\n  background-color: #fff !important;\n}\n\n.createCategoryHeading {\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #5271FF;\n  margin-bottom: 10px;\n}\n\n.categoryInput{\n  width: 100%;\n}\n\n.createCategoryForm{\n  border: 0.3px solid black;\n  border-radius: 5px;\n  background-color: #F7F6F9;\n  padding: 20px 20px 10px 20px;\n  margin-top: 10px;\n  font-size: 0.75rem;\n}\n\n.createCategoryForm input{\n  padding: 5px 5px;\n}\n\n.createCategoryForm input::placeholder{\n  color: #ADA8A8;\n  font-weight: 700;\n  font-size: 0.75rem;\n}\n\n.createCategorySaveButton{\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.createCategorySaveButton button{\n  background: linear-gradient(90deg, #4E6CF3 0%, #3448A3 100%);\n  color:#fff;\n  border: 0.5px solid #BEBEBE;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  padding: 8px 25px;\n  cursor: pointer;\n}\n\n/* ── Dark mode ── */\n.dark .categoryMenuGrid {\n  background-color: #0f172a !important;\n  color: #f1f5f9;\n}\n\n.dark .createCategoryContainer {\n  background-color: #1e293b !important;\n  color: #f1f5f9;\n}\n\n.dark .createCategoryForm {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .createCategoryHeading {\n  color: #818cf8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
